import { Suspense, useEffect, useState } from 'react'
import {
  Card,
  CardBody,
  CardImg,
  CardTitle,
  Col,
  Container,
  Modal,
  ModalBody,
  Row,
} from 'reactstrap'
import AxiosInstance from 'utils/AxiosInstance'
import Loader from '../Loader'
import DefaultImage from 'assets/img/default-image.png'
import { Link, useLocation, useHistory } from 'react-router-dom'
import CustomModalHeader from 'components/Custom/CustomModalHeader'
import { useSelector } from 'react-redux'
import { assignUserToCourse } from 'store/AllCourses/actions'
import { useDispatch } from 'react-redux'
import { fetchCourses } from 'store/Course/actions'
import CodeModal from './CodeModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDollarSign, faGift, faLock } from '@fortawesome/free-solid-svg-icons'
import CourseModalCode from './CourseModalCode'
import { loadStripe } from '@stripe/stripe-js'

const isCourseAssigned = (courses, courseId) => {
  if (courses?.find((course) => course?.course_id == courseId)) {
    return true
  } else {
    return false
  }
}

// leart

function PublicCatalog() {
  const dispatch = useDispatch()
  const { courses: assignedCourses } = useSelector((state) => state.courses)

  const [courses, setCourses] = useState([])
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    AxiosInstance.get(`/public-catalog`).then((data) => {
      setCourses(data)
      setLoading(false)
    })
  }, [])

  const isAuthed = useSelector((state) => state.auth.isAuthenticated)
  const { theme } = useSelector((state) => state.themeConfig)

  const [viewCourseModal, setViewCourseModal] = useState(false)
  const [enterCodeModal, setEnterCodeModal] = useState(false)
  const [modalCourse, setModalCourse] = useState(null)
  const location = useLocation()

  const pathCourseId = location?.pathname?.split('/')?.at(2)

  const [unlockedCourse, setUnlockedCourse] = useState(null)

  useEffect(() => {
    if (pathCourseId) {
      setViewCourseModal(true)
    }
  }, [pathCourseId])

  useEffect(() => {
    if (viewCourseModal && !modalCourse) {
      setModalCourse(
        courses?.find((course) => course?.course_id == pathCourseId)
      )
    }
  }, [courses, modalCourse, pathCourseId, viewCourseModal])

  useEffect(() => {
    if (isAuthed) {
      dispatch(fetchCourses())
    }
  }, [dispatch, isAuthed])

  return (
    <>
      {!isAuthed && (
        <div className='mt-3 d-flex justify-content-between align-items-center px-3'>
          <Link to='/'>
            <img
              className='light-image'
              src={
                theme.loginLogo && theme.loginLogo.url
                  ? theme.loginLogo.url
                  : 'https://d2n2qux042tjxn.cloudfront.net/e999b4a0-91fe-11ef-8956-d31ccf08955c.png'
              }
              alt=''
              style={{ maxWidth: '150px' }}
            />
          </Link>
          <Link to='/auth/login' className='btn btn-info'>
            Login
          </Link>
        </div>
      )}
      <Container
        className={`${isAuthed && 'mt--6'}`}
        fluid
        style={{ marginTop: !isAuthed ? '100px' : '' }}
      >
        <Card className='mt--6 py-4 px-3' style={{ minHeight: '85vh' }}>
          {loading ? (
            <div
              className='dFlex justifyCenter itemsCenter textCenter'
              style={{ minHeight: '80vh' }}
            >
              <Loader />
            </div>
          ) : (
            <div style={{ minHeight: '80vh' }}>
              <Suspense
                fallback={
                  <div
                    className='dFlex justifyCenter itemsCenter textCenter'
                    style={{ minHeight: '80vh' }}
                  >
                    <Loader />
                  </div>
                }
              >
                {courses.length === 0 ? (
                  <div
                    className='dFlex justifyCenter itemsCenter textCenter'
                    style={{ minHeight: '80vh' }}
                  >
                    <p className='text-primary blockquote font-weight-normal'>
                      No data here
                    </p>
                  </div>
                ) : (
                  <>
                    <button
                      onClick={() => setEnterCodeModal(true)}
                      className='btn btn-info mb-4'
                    >
                      Enter Code
                    </button>
                    <Row className='d-flex flex-wrap justify-content-start'>
                      {courses.map((course, courseIndex) => (
                        <Col
                          key={course.course_id}
                          xs={12}
                          sm={6}
                          md={6}
                          lg={4} // Adjust column size for different breakpoints
                          className='mb-4 d-flex align-items-stretch'
                        >
                          <CourseDetails
                            key={course.course_id}
                            course={course}
                            isAuthed={isAuthed}
                            setViewCourseModal={setViewCourseModal}
                            viewCourseModal={viewCourseModal}
                            setModalCourse={setModalCourse}
                          />
                        </Col>
                      ))}
                    </Row>
                  </>
                )}
              </Suspense>
            </div>
          )}
        </Card>
      </Container>
      {enterCodeModal && (
        <CodeModal
          enterCodeModal={enterCodeModal}
          setEnterCodeModal={setEnterCodeModal}
          setUnlockedCourse={setUnlockedCourse}
        />
      )}
      {viewCourseModal && (
        <ViewCourseModal
          course={modalCourse}
          viewCourseModal={viewCourseModal}
          setViewCourseModal={setViewCourseModal}
          isAuthed={isAuthed}
          alreadyAssigned={isCourseAssigned(
            assignedCourses,
            modalCourse?.course_id
          )}
          unlockedCourse={unlockedCourse}
          setUnlockedCourse={setUnlockedCourse}
          setEnterCodeModal={setEnterCodeModal}
        />
      )}
    </>
  )
}

const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return {
      truncatedDesc: `${text.slice(0, maxLength)}...`,
      canToggle: true,
    }
  }
  return {
    truncatedDesc: text,
    canToggle: false,
  }
}

const showCardDescription = (
  course,
  maxLength,
  showFullDescription,
  toggleShowFullDescription
) => {
  const { truncatedDesc, canToggle } = truncateText(
    course.description || '...',
    maxLength
  )

  const displayDescription =
    showFullDescription && canToggle ? course.description : truncatedDesc
  return (
    <>
      <div className={'px-2 py-1'}>
        {displayDescription}
        {canToggle && (
          <span
            className='view-more-less-text pl-1'
            style={{ fontSize: '12px' }}
            onClick={toggleShowFullDescription}
          >
            {showFullDescription ? 'View less' : 'View more'}
          </span>
        )}
      </div>
    </>
  )
}

const CourseDetails = ({ course, setViewCourseModal, setModalCourse }) => {
  const [showFullDescription, setShowFullDescription] = useState(false)

  const toggleShowFullDescription = (e) => {
    e.preventDefault()
    setShowFullDescription(!showFullDescription)
  }

  return (
    <>
      <Link
        to={`/public-catalog/${course?.course_id}`}
        onClick={() => {
          setViewCourseModal(true)
          setModalCourse(course)
        }}
        className='p-0 shadow learning-plan-card h-100 w-100'
        style={{ minHeight: '300px' }}
      >
        <div style={{ height: '100%' }}>
          <div
            style={{
              filter: "blur('1.2px')",
              height: '70%',
            }}
            className={'card-image-box'}
          >
            <CardImg
              style={{
                width: '100%',
                position: 'relative',
                objectFit: 'cover',
                height: 'max(100%, 100%)',
              }}
              alt='...'
              src={course.image ? course.image : DefaultImage}
              top
            />
            <div
              style={{
                position: 'absolute',
                bottom: 0,
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                color: '#fff',
              }}
            >
              <div className={'card-content mb text-sm '}>
                {' '}
                {showCardDescription(
                  course,
                  30,
                  showFullDescription,
                  toggleShowFullDescription
                )}
              </div>
            </div>
            <div className={'img-overlay'}></div>
          </div>

          <CardBody
            className='p-2 px-3 border-top course-details'
            style={{
              height: '30%',
              maxHeight: '180px',
              backgroundColor: '#cfcfcf',
            }}
          >
            <div className='d-flex flex-column justify-content-between pb-0'>
              <div>
                <CardTitle
                  className='d-flex justify-content-between learning-plan-title'
                  tag='h3'
                >
                  <span title={course.name} className='course-name'>
                    {course.name.replaceAll(' ', '').length >= 28
                      ? course.name.slice(0, 28) + '...'
                      : course.name}
                  </span>
                </CardTitle>
              </div>
              <Row
                className='justify-content-between '
                style={{ minHeight: '43px' }}
              >
                <CourseEnrollment
                  enrollmentType={course?.enrollment_type}
                  price={course?.price}
                />
              </Row>
            </div>
          </CardBody>
        </div>
      </Link>
    </>
  )
}

const ViewCourseModal = ({
  course,
  viewCourseModal,
  setViewCourseModal,
  isAuthed,
  alreadyAssigned,
  unlockedCourse,
  setUnlockedCourse,
}) => {
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    return () => {
      setUnlockedCourse(null)
    }
  }, [setUnlockedCourse])

  const makePayment = async () => {
    const stripe = await loadStripe(
      'pk_live_51Kb6C0Dgty3XYJPRPNN4RezW2CujdAwJslp86v7XnexmqyhXQqUHnLNqd4o4OJyRfcg47c4Ph7CnNx3MQLGF1z3e00LYdJ1qYw'
    )

    AxiosInstance.post(`/courses/create-checkout-session`, {
      products: [
        {
          course: {
            id: course.id,
            name: course.name,
            price: course.price,
            image: course.image,
          },
        },
      ],
    }).then((data) => {
      stripe.redirectToCheckout({ sessionId: data.id })
    })
  }

  const [showCourseModalCode, setShowCourseModalCode] = useState(false)

  return (
    <Modal
      toggle={() => {
        setViewCourseModal(false)
        history.push(`/public-catalog`)
      }}
      isOpen={viewCourseModal}
      centered
      size='xl'
      style={{
        maxWidth: '90%',
        width: '100%',
        overflowY: 'auto',
        // maxHeight: '90vh',
      }}
      className='scrollbar'
    >
      <CustomModalHeader
        title={'Course'}
        toggle={() => {
          setViewCourseModal(false)
          history.push(`/public-catalog`)
        }}
      />
      <ModalBody style={{ padding: '20px' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            backgroundColor: '#f0f0f0',
          }}
        >
          <div
            style={{
              display: 'flex',
              flex: '40%',
              backgroundColor: '#f4f4f4', // Light gray background
              padding: '20px',
              borderRadius: '8px',
            }}
          >
            <div
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '40px',
                fontWeight: 'bold',
                textAlign: 'center',
              }}
            >
              <div>{course?.name}</div>
              <p style={{ fontSize: '20px' }}>
                {course?.first_name} {course?.last_name}
              </p>

              {!showCourseModalCode && (
                <Link
                  className='btn btn-info my-3 py-3'
                  style={{ gap: '65px' }}
                  to={
                    !isAuthed
                      ? '/auth/login'
                      : course?.enrollment_type === 2 && !alreadyAssigned
                      ? undefined
                      : `/course/${course?.course_id}`
                  }
                  onClick={(e) => {
                    if (!unlockedCourse && course?.enrollment_type === 1) {
                      e.preventDefault()
                      setShowCourseModalCode(true)
                      return
                    }

                    if (
                      isAuthed &&
                      !alreadyAssigned &&
                      course?.enrollment_type === 2
                    ) {
                      makePayment()
                      return
                    }

                    if (isAuthed) {
                      dispatch(
                        assignUserToCourse(
                          course.course_id,
                          course?.enrollment_type === 1
                        )
                      )
                    } else {
                      localStorage.setItem(
                        'public_catalog_course_id',
                        course.course_id
                      )
                    }
                  }}
                >
                  {!alreadyAssigned || !isAuthed
                    ? course?.enrollment_type !== 2
                      ? 'Take this course'
                      : 'Buy this course'
                    : 'Go to this course'}
                  {(!alreadyAssigned || !isAuthed) &&
                    course?.enrollment_type === 1 &&
                    !unlockedCourse && (
                      <FontAwesomeIcon icon={faLock} className='ml-2' />
                    )}
                </Link>
              )}

              {showCourseModalCode && (
                <CourseModalCode
                  courseId={course.course_id}
                  enrollmentType={course?.enrollment_type}
                />
              )}
            </div>

            <div
              style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                src={course?.image || DefaultImage} // Replace with actual image path
                alt={course?.name}
                style={{
                  maxWidth: '80%',
                  maxHeight: '80%',
                  objectFit: 'cover',
                  borderRadius: '8px',
                }}
              />
            </div>
          </div>

          <div
            style={{
              flex: '60%',
              backgroundColor: 'white',
              padding: '20px',
              marginTop: '10px',
              borderRadius: '8px',
              overflowY: 'auto',
              fontSize: '16px',
            }}
          >
            <h1>About this course</h1>
            <p>{course?.description}</p>
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

const CourseEnrollment = ({ enrollmentType, price }) => {
  return (
    <Col className='course-infos d-flex align-items-center justify-content-end'>
      <h5 className='pr-3 text-nowrap pt-2' style={{ color: '#525F7F' }}>
        {enrollmentType === 0 && (
          <>
            <FontAwesomeIcon icon={faGift} className='mr-1' />
            FREE
          </>
        )}
        {enrollmentType === 1 && (
          <>
            <FontAwesomeIcon icon={faLock} className='mr-1' />
            LOCKED
          </>
        )}
        {enrollmentType === 2 && (
          <>
            <FontAwesomeIcon icon={faDollarSign} className='mr-1' />
            {price}
          </>
        )}
      </h5>
    </Col>
  )
}
export default PublicCatalog
